import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.wrapper = this.el.querySelector('.images-block__images')
    this.images = [...this.el.querySelectorAll('.images-block__image')]
    this.pagers = [...this.el.querySelectorAll('.images-block__pager')]
    this.timerProgress = this.el.querySelector('.images-block__timer__progress')

    this.currentIndex = 0
    this.maxIndex = this.images.length - 1
    this.interval = 6
    this.transitionDuration = 1
    this.isTransitioning = false
    this.isInView = false
    this.io = new IntersectionObserver(this.inView.bind(this))

    this.events = { click: {
      clickPager: 'clickPager',
      clickedPrev: 'prev',
      clickedNext: 'next'
    } }

    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        if (!this.isTransitioning)
          this.next()
      }
    })

    this.tl.fromTo(
      this.timerProgress,
      { clipPath: 'polygon(50% 50%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%)' },
      {
        duration: this.interval / 4,
        ease: 'none',
        clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)'
      }
    ).fromTo(
      this.timerProgress,
      { clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)' },
      {
        duration: this.interval / 4,
        ease: 'none',
        clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)'
      }
    )

    this.tl.fromTo(
      this.timerProgress,
      { clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)' },
      {
        duration: this.interval / 4,
        ease: 'none',
        clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 100%)'
      }
    )
      .fromTo(
        this.timerProgress,
        { clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 100%)' },
        {
          duration: this.interval / 4,
          ease: 'none',
          clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%)'
        }
      )

    this.transitionTl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.isTransitioning = false

        if (this.isInView)
          this.tl.play(0)
      }
    })

    this.transitionTl.to(this.timerProgress, {
      duration: this.transitionDuration,
      ease: 'none',
      opacity: 0
    })
      .set(this.timerProgress, {
        clipPath: 'polygon(50% 50%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%)',
        clearProps: 'opacity'
      })

    this.io.observe(this.wrapper)
  }

  inView([entry]) {
    this.isInView = entry.isIntersecting

    if (!this.isTransitioning) {
      this.isInView
        ? this.tl.play(0)
        : this.tl.pause()
    }
  }

  clickPager(e) {
    if (!e.currentTarget.classList.contains('active')) {
      this.goTo(this.pagers.indexOf(e.currentTarget))
    }
  }

  prev() {
    this.goTo(this.currentIndex - 1)
  }

  next() {
    this.goTo(this.currentIndex + 1)
  }

  goTo(targetIndex) {
    const index = targetIndex < 0
      ? this.maxIndex
      : targetIndex > this.maxIndex
        ? 0
        : targetIndex

    if (!this.tl.paused())
      this.tl.pause()

    this.changeImage(index)
  }

  changeImage(index) {
    if (index === this.currentIndex || index > this.maxIndex || index < 0 || this.isTransitioning)
      return

    this.isTransitioning = true

    this.images[index].classList.add('active')
    this.images[this.currentIndex].classList.remove('active')
    this.pagers[index].classList.add('active')
    this.pagers[this.currentIndex].classList.remove('active')

    this.currentIndex = index

    this.transitionTl.invalidate().play(0)
  }

  destroy() {
    this.io.disconnect()
    this.tl.kill()
    this.transitionTl.kill()
  }
}
